module.exports = __webpack_public_path__ + "img/prize-05.5c8d6992.png";